export default __webpack_public_path__ + "media/images/corporate/apartments/third_slide_md-46498e859221d9f0e6169e1d71503b01.png";